import React from 'react';
import type { IFilterOption, TFilterField } from '../HBFilters.types';
import { useFilters } from '../hooks/useFilters';
import { ListItem } from './PopoverBase';
import FilterTag from './FilterTag';
import { Check16 } from '@honeybook/icons';
import { vars } from '../../../theme';
import { flexCenterAll, setIconFillColor } from '../../../styles/mixins';
import styled from 'styled-components';

interface IHBSingleSelectFilterProps {
    field: TFilterField;
    value: IFilterOption | null;
}

interface IFilterOptionProps {
    option: IFilterOption;
    isSelected: boolean;
    onToggle: (option: IFilterOption) => void;
}

const FilterOption = ({ option, isSelected, onToggle }: IFilterOptionProps) => (
    <ListItem
        testId="single-select-filter-list-item"
        $alignment={'spaced'}
        key={option.value}
        onClick={() => onToggle(option)}
        size="md"
        rounded
    >
        <FilterTag
            tag={{
                _id: option.value,
                tag_name: option.label,
                color: option.color
            }}
        />
        {isSelected && (
            <SelectedCheck>
                <Check16 />
            </SelectedCheck>
        )}
    </ListItem>
);

const HBSingleSelectFilter = ({ field, value }: IHBSingleSelectFilterProps) => {
    const { toggleSingleSelect } = useFilters();

    return (
        <>
            {field.options.map(option => (
                <FilterOption
                    key={option.value}
                    option={option}
                    isSelected={value?.value === option.value}
                    onToggle={toggledOption =>
                        toggleSingleSelect(field.id, toggledOption)
                    }
                />
            ))}
        </>
    );
};

// -------------------------------- Styles -------------------------------- //
const SelectedCheck = styled.div`
    ${flexCenterAll}
    ${() => setIconFillColor(vars.colors.text.accent)}
`;

export default HBSingleSelectFilter;
